import { createContext, useContext, useCallback, useState } from "react";

const AskNiqContext = createContext(null);

export function AskNiqProvider({ children }) {
  const [trigger, setTrigger] = useState(null);

  const requestAsk = useCallback((question, meta) => {
    setTrigger({ question, meta, ts: Date.now() });
  }, []);

  return (
    <AskNiqContext.Provider value={{ trigger, requestAsk }}>
      {children}
    </AskNiqContext.Provider>
  );
}

export function useAskNiq() {
  return useContext(AskNiqContext);
}
